import { useMemo } from 'react'
import { useNavigate } from 'react-router'
import { Button } from '../../../components/button/button'
import { Text } from '../../../components/texts/text'
import { _colorText, _size, _sizeText, _style } from '../../../core/core'
import { useOrder } from '../../../entities/order/context/OrderContext'
import "./MenuDown.css"


export const MenuDown = ({ children }: { children: React.ReactNode }) => {
    return (
        <div className="menu-down">
            {children}
        </div>
    )
}

export const CatalogMenu = () => {
    const navigate = useNavigate();
    return (
        <MenuDown>
            <Button
                size={_size.M}
                onClick={() => navigate('/uslugi')}
                width={"100%"}
                className="flex justify-center items-center"
            >
                В каталог
            </Button>
        </MenuDown>
    )
}

export const OrderMenu = () => {
    const { form, service, price, handleCreateOrder } = useOrder();

    const menuTitle = useMemo(() => {
        if (form.urlError) {
            return <Text size={_sizeText.xs} color={_colorText.negative}>
                {form.urlError}
            </Text>
        }
        if (form.emailError) {
            return <Text size={_sizeText.xs} color={_colorText.negative}>
                {form.emailError}
            </Text>
        }
        if (price.nextPrice) {
            return <Text size={_sizeText.xs} color={_colorText.neutral}>
                {price.currentPrice}₽/шт, Ещё {price.leftToNext} шт, и будет {price.nextPrice}₽/шт</Text>
        }
        return <Text size={_sizeText.xs} color={_colorText.neutral}>
            Лучшая цена - это всегда приятно
        </Text>
    }, [form.urlError, form.emailError, price.nextPrice, price.currentPrice, price.leftToNext]);

    if (!service) {
        return null;
    }
    return (
        <MenuDown>
            {menuTitle}
            <Button size={_size.M} style={_style.secondary} width={"100%"} onClick={handleCreateOrder}>
                <Text>{service.morda.preferences[0].text}</Text>
                <Text size={_sizeText.mbold}>Оплатить {price.currentPrice * form.count} ₽</Text>
                <Text>{form.count} шт</Text>
            </Button>
        </MenuDown>
    )
}